import React from 'react';
import { Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Drop-in replacement for MUI <Dialog> that adds a consistent close (✕) button in the top-right
 * corner of every popup, wired to the dialog's existing `onClose`. Use it exactly like <Dialog>:
 * all props (open, onClose, fullWidth, maxWidth, PaperProps, …) pass straight through.
 *
 * - The ✕ calls `onClose(event, 'closeButton')`, so handlers that ignore the reason still close, and
 *   any that special-case `backdropClick` are unaffected.
 * - Pass `showClose={false}` to opt a specific dialog out (e.g. one that already renders its own ✕).
 */
export default function AppDialog({ onClose, showClose = true, children, ...props }) {
  return (
    <Dialog onClose={onClose} {...props}>
      {showClose && onClose && (
        <IconButton
          aria-label="Close"
          onClick={(e) => onClose(e, 'closeButton')}
          sx={{ position: 'absolute', right: 8, top: 8, zIndex: 2, color: (t) => t.palette.grey[600] }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
      {children}
    </Dialog>
  );
}
